const JackpotPrizeNotificationEventName = 'jackpotPrize';
const ArcadeWinnerNotificationEventName = 'arcadeWinner';
const ArcadeWinnerReceivedEventName = 'arcadeReceived';

export { JackpotPrizeNotificationEventName, ArcadeWinnerNotificationEventName, ArcadeWinnerReceivedEventName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/models/events.ts